export const UPDATE_RECEIPT_CALL_BEGIN = "UPDATE_RECEIPT_CALL_BEGIN";
export const MARK_RECEIPT_GENERATED = "MARK_RECEIPT_GENERATED";
export const INCREMENT_FAILED_RECEIPT_COUNT = "INCREMENT_FAILED_RECEIPT_COUNT";
export const UPDATE_RECEIPT_CALL_END = "UPDATE_RECEIPT_CALL_END";

export const updateReceiptCallEnd = () => ({
  type: UPDATE_RECEIPT_CALL_END,
});
export const incrementFailedReceiptCallCount = () => ({
  type: INCREMENT_FAILED_RECEIPT_COUNT,
});
export const markReceiptGenerated = () => ({
  type: MARK_RECEIPT_GENERATED,
});
export const updateReceiptCallBegin = () => ({
  type: UPDATE_RECEIPT_CALL_BEGIN,
});